import { useRef } from "react";

import styles from "./textInput.module.css";

export const TextInput = ({ leftContent, rightContent, value, setValue, ...props }) => {
    const ref = useRef(null);

    return (
        <div className={styles.text_input_container} onClick={() => ref.current?.focus()}>
            {leftContent}
            <input
                ref={ref}
                className={styles.text_input}
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Найти"
                {...props}
            />
            {rightContent}
        </div>
    )
}
